module.exports = __webpack_public_path__ + "img/philhealthtable2019to2025.bb4e5497.jpg";